import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'

interface WindowSize {
  width: number
  height: number
  isLandscape: boolean
}

function useWindowSize(): WindowSize {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: window.innerWidth,
    height: window.innerHeight,
    isLandscape: isMobile && window.innerWidth > window.innerHeight,
  })

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        isLandscape: isMobile && window.innerWidth > window.innerHeight
      })
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []);

  return { ...windowSize }
}

export default useWindowSize
